import { JWTAuth } from "../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../lib/js-apiclient/src/AdvancedApiClient";

export class PosApiClient extends AdvancedApiClient {

    static entityType = "PointOfSale"

    constructor(token, id) {
        super();

        this.setEntityType(PosApiClient.entityType);

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/pos/{id}")
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/pos")
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}